import { html, css } from "../utils/template-literal-tags";
import dayjs from "dayjs";

class RhythmTagButton extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    this.shadowRoot.innerHTML = html`
      <style>
        :host {
          display: inline-block;
          min-height: 30px;
        }

        span.rhythm-pill {
          background: var(--dark7);
          border-radius: 5px;
          padding: 2px 4px;
          font-size: 0.75em;
          text-align: center;

          display: inline-flex;
          flex-wrap: wrap;
          justify-content: center;
          width: min-content;
          position: relative;
          top: -2px;

          user-select: none;
          cursor: pointer;

          span.timestamp {
            font-size: 1.1em;
            display: none;
          }

          &.selected {
            background: var(--dark8);
            top: 0;

            span.timestamp {
              display: inline;
            }
          }
        }
      </style>
      <span class="rhythm-pill">
        <span class="tag"> <span class="hash">#</span><span class="tag-name">${this.dataset.tag}</span> </span>
        <span class="timestamp"></span>
      </span>
    `;
    this.pill = this.shadowRoot.querySelector(".rhythm-pill");
    this.timestamp = this.shadowRoot.querySelector("span.timestamp");
  }

  connectedCallback() {
    this.getInitialTimestamp();
    this.render();

    this.addEventListener("click", () => {
      if (this.pill.classList.contains("selected")) {
        this.deselect();
      } else {
        this.select();
      }
    });
  }

  getInitialTimestamp() {
    // read it out of log that has been sent
  }

  render(time = null) {
    const timestamp = time === null ? "" : dayjs(time).format("HH:mm");

    this.timestamp.textContent = timestamp;
  }

  /**
    1. insert the timestamp into the pill
    2. send entry
  */
  async select() {
    this.pill.classList.add("selected");
    const now = dayjs();

    const event = new CustomEvent("submit-data", {
      bubbles: true,
      composed: true,
      detail: {
        endpoint: "/entries/new-entry",
        method: "POST",
        payload: {
          entry: {
            startTime: now,
            tags: `#${this.dataset.tag}`,
          },
        },
      },
    });

    this.dispatchEvent(event);

    if (event.detail.response) {
      this.dataset.received = "true";
    }

    this.render(now);
  }

  /**
    1. remove timestamp from pill
    2. send update to remove timestamp from entry
  */
  deselect() {
    this.pill.classList.remove("selected");
    this.timestamp.textContent = "";
    this.render();
  }
}

customElements.define("rhythm-tag-button", RhythmTagButton);
